import styles from '@/shared/ui/layout/topbar/ui/topbar.module.scss';
import cn from 'classnames';
import { HTMLAttributes } from 'react';


export const TopbarNavigation = ({ className, ...props }: HTMLAttributes<HTMLElement>) => {
    return (
        <nav
            className={ cn(styles.nav, className) }
            { ...props }
        />
    );
};
